// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import configureWebComponents from './configureWebComponents';
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy/index';
import configureWebActions from './configureWebActions';
// import cookiesPolicy from './components/CookiesPolicy';
// import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
// import 'bootstrap/collapse';

cookiesPolicy({
  enableImg: false,
  enableTechnicalButton: true,
  messages: {
    cs: {
      perex: 'Chceme, aby&nbsp;pro&nbsp;vás&nbsp;bylo procházení webu co&nbsp;nejpříjemnější. Proto používáme soubory cookies, které ho&nbsp;pomáhají neustále rozvíjet a&nbsp;zlepšovat. Navíc nám&nbsp;a&nbsp;našim partnerům umožňují zobrazovat relevantní obsah jen&nbsp;pro&nbsp;vás. Ke&nbsp;zpracování některých cookies potřebujeme váš&nbsp;souhlas, který nám&nbsp;dáte kliknutím na&nbsp;„Povolit všechny cookies“. Nastavení si&nbsp;můžete kdykoliv upravit. Poskytnuté informace jsou v&nbsp;bezpečí a&nbsp;nedostane se&nbsp;k&nbsp;nim, kdo&nbsp;nemá. Více najdete na&nbsp;stránce <a class="cookies-policy__link" href="/cs/informace-o-webu">Informace o&nbsp;webu</a>.',
    },
  },
  settingsMessages: {
    cs: {
      perex: 'Zde si můžete nastavit, jaké soubory cookies budeme zpracovávat. Více informací najdete na stránce <a class="cookies-settings__link" href="/cs/informace-o-webu">Informace o&nbsp;webu</a>.',
    },
  },

});
connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
// autoTitleLinksWithBlankTarget();
// cookiesPolicy();
// phoneLink();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js